import { Window } from './Window';
import React from 'react';
import { IconV2 as Icon } from '@kizi/shared-components';
import { Div } from '@kizi/core-components';

export const EnergyProtection = () => {
  const [isOpen, seIsOpen] = React.useState<boolean>(false);
  const onOpen = React.useCallback(() => {
    seIsOpen(true);
  }, [seIsOpen]);
  const onClose = React.useCallback(() => {
    seIsOpen(false);
  }, [seIsOpen]);

  const css = {
    borderRadius: '40px',
    background: '#E3F1FF',
    padding: '4px 8px',
    gap: '4px',
    marginTop: '5px',
    marginBottom: '5px',
    '>div': {
      color: '#105ECB',
      fontWeight: '600',
    },
  };

  const modalContent = `
    <p>De Energierekening Beschermer is een gratis service die je krijgt wanneer je een energiecontract via het Energiecollectief van Consumentenbond aanvraagt. Dit product biedt een financiële buffer bij onverwachte situaties, zoals een ongeval of onvrijwillige werkloosheid. Het doel is om jou en je nabestaanden te ondersteunen door je energierekening tijdelijk te verlichten.</p>
    <p style='margin-top: 10px; margin-bottom'><strong>Wat krijg je met de Energierekening Beschermer?</strong></p>
    <ul style='margin-left: 22px;'><li>Tijdelijke ondersteuning als je door een ongeval tijdelijk niet kunt werken of als je onvrijwillig werkloos wordt. Je krijgt dan jouw termijnbedrag (tot €300 per maand) uitgekeerd, maximaal voor 6 maanden.</li><li>Eenmalige uitkering bij blijvende invaliditeit. Bij blijvende invaliditeit door een ongeval ontvang je een eenmalige uitkering van €1.500.</li><li>Eenmalige uitkering bij overlijden. In geval van overlijden door een ongeval ontvangen je nabestaanden een eenmalige uitkering van €1.500.</li></ul>
    <p><b>Hoe werkt het?</b></p>
    <ul style='margin-left: 22px;'><li>De Energierekening Beschermer is automatisch actief en loopt maximaal 1 jaar, zolang je energiecontract actief is. Na een jaar wordt de beschermer automatisch opgezegd. Hier hoef je niets voor te doen.</li><li>Bij vroegtijdige opzegging van je energiecontract stopt de dekking automatisch.</li><li>Dit product is volledig gratis – je betaalt geen premie!</li></ul>
  `;

  return (
    <>
      <Div
        display="flex"
        css={css}
        onClick={onOpen}
        style={{
          cursor: 'pointer',
        }}
      >
        <Icon
          my="auto"
          name={'energy-protection'}
          width={28}
          fill={'#105ECB'}
        />
        <Div fontSize={2} my="auto">
          Gratis Energierekening Beschermer
        </Div>
        <Icon my="auto" name={'round-warning'} width={16} fill={'#105ECB'} />
      </Div>
      <Window
        onClose={onClose}
        show={isOpen}
        title={'Wat is de Energierekening Beschermer?'}
        type="modal"
        modalProps={{
          modalContainerDivProps: {
            maxWidth: 780,
            maxHeight: '100%',
            my: 'auto',
            css: {
              boxSizing: 'border-box',
            },
          },
          title: 'Wat is de Energierekening Beschermer?',
          show: isOpen,
          children: <div dangerouslySetInnerHTML={{ __html: modalContent }} />,
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: modalContent }} />
      </Window>
    </>
  );
};
